<template>
  <SplashScreen v-if="isLoading" />
  <template v-else>
    <Nav
      :data="data"
      @open-contact="isContactModalOpen = true"
    />
    <router-view :data="data" />
    <SiteFooter
      :data="data"
      @open-contact="isContactModalOpen = true"
    />
    <ContactModal
      :open="isContactModalOpen"
      :data="data"
      @close="isContactModalOpen = false"
    />
  </template>
</template>

<script>
import Nav from '@/views/Nav.vue'
import SplashScreen from '@/views/0_SplashScreen.vue'
import SiteFooter from '@/views/Footer.vue'
import ContactModal from '@/components/ContactModal.vue'
import { fetchTemplierContent, getContent } from '@/content/templiersContent'

// helpers de méta au niveau module (indépendants du binding `this`, car le
// watcher `immediate` peut se déclencher avant l'attache des méthodes)
function setMetaName(name, content) {
  const el = document.querySelector(`meta[name="${name}"]`)
  if (el && content != null) el.setAttribute('content', content)
}
function setMetaProp(property, content) {
  const el = document.querySelector(`meta[property="${property}"]`)
  if (el && content != null) el.setAttribute('content', content)
}

export default {
  name: 'App',
  components: {
    Nav,
    SplashScreen,
    SiteFooter,
    ContactModal
  },
  data() {
    return {
      isLoading: true,
      isContactModalOpen: false,
      content: null
    }
  },
  computed: {
    data() {
      return this.content || getContent()
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(content) {
        const seo = content?.seo
        if (!seo) return
        document.documentElement.lang = seo.lang
        document.title = seo.title
        setMetaName('description', seo.description)
        setMetaName('keywords', seo.keywords)
        // garde les balises réseaux sociaux synchro (le CMS pourra les piloter)
        const ogDesc = seo.ogDescription || seo.description
        const ogImg = content?.hero?.image
        setMetaProp('og:title', seo.title)
        setMetaProp('og:description', ogDesc)
        setMetaName('twitter:title', seo.title)
        setMetaName('twitter:description', ogDesc)
        if (ogImg && /^https?:\/\//.test(ogImg)) {
          setMetaProp('og:image', ogImg)
          setMetaName('twitter:image', ogImg)
        }
      }
    }
  },
  async mounted() {
    const start = Date.now()
    const minSplash = 2600 // durée de l'animation d'ouverture du logo

    this.content = await fetchTemplierContent()

    const hideSplash = () => {
      const elapsed = Date.now() - start
      const remaining = Math.max(0, minSplash - elapsed)
      window.setTimeout(() => { this.isLoading = false }, remaining)
    }
    const previewSrc = this.data?.hero?.image
    if (previewSrc) {
      const img = new Image()
      img.src = previewSrc
      img.onload = hideSplash
      img.onerror = hideSplash
    } else {
      hideSplash()
    }
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  background: $navy;
  // clip du débord horizontal des bandeaux inclinés, sans bloquer le scroll
  // vertical (clip sur un div, pas sur l'élément racine)
  overflow-x: clip;
}
</style>
